<template>
  <v-card class='pa-4'>
    <v-card-title style='flex-direction: column'>
      <v-icon color='error' size='200'>do_not_disturb_alt</v-icon>
      <h2 class='error--text'>Limite de Compras</h2>
      <v-layout justify-space-between style='width: 100%'>
        <v-flex xs4>
          <v-select
            :items="[
              { text: 'No APP', value: true },
              { text: 'No Posto', value: false },
            ]"
            solo
            dense
            flat
            hide-details
            persistent-hint
            single-line
            v-model='limiteCompra.is_app'
          ></v-select>
        </v-flex>
        <v-flex xs3 v-if='existe'>
          <v-btn small round color='error' @click='dialogDeletarLimite = true'
            >Deletar</v-btn
          >
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-alert
      v-show='alerta'
      :type='tipo'
      outline
      style='width: 100%'
      class='pa-2'
      :value='true'
    >
      <h4>{{ alerta }}</h4>
    </v-alert>
    <v-card-text>
      <v-checkbox
        v-model='tem_limite_valor'
        color='green'
        class='mt-0'
        :hide-details='tem_limite_valor'
      >
        <template slot='label'>
          <span class='body-2 grey--text'>Valor de compra</span>
        </template>
      </v-checkbox>
      <v-slide-x-transition>
        <v-layout
          wrap
          justify-space-between
          v-if='tem_limite_valor'
          class='mt-4'
        >
          <v-flex xs6>
            <v-text-field
              outline
              v-money='money'
              label='valor'
              v-model.lazy='valor'
            />
          </v-flex>
          <v-flex xs4>
            <v-select
              label='Período'
              :items="[
                { text: 'Diário', value: 0 },
                { text: 'Semanal', value: 1 },
                { text: 'Mensal', value: 2 },
              ]"
              v-model='limiteCompra.periodo'
              outline
            />
          </v-flex>
        </v-layout>
      </v-slide-x-transition>
      <v-checkbox
        v-model='tem_limite_combustivel'
        color='green'
        class='mt-0'
        :hide-details='tem_limite_combustivel'
      >
        <template slot='label'>
          <span class='body-2 grey--text'>Valor por Combustível</span>
        </template>
      </v-checkbox>
      <v-slide-x-transition>
        <v-layout
          wrap
          justify-space-between
          v-show='tem_limite_combustivel'
          class='mt-4'
        >
          <v-flex xs5>
            <v-select
              label='Combustível'
              :items='combustiveis'
              v-model='combustivel'
              item-text='nome'
              outline
              return-object
            >
              <template v-slot:selection='item'>
                <v-list-tile-avatar>
                  <svg-filler
                    :path='
                      item.item.icone
                        ? require(`@/assets/combs/${item.item.icone}.svg`)
                        : require(`@/assets/combs/gas.svg`)
                    '
                    width='50px'
                    height='50px'
                    :fill='item.item.color'
                  />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-text='item.item.nome'
                    class='font-weight-medium'
                    :style='{ color: item.item.color }'
                  ></v-list-tile-title>
                </v-list-tile-content>
              </template>
              <template v-slot:item='item'>
                <v-list-tile-avatar>
                  <svg-filler
                    :path='
                      item.item.icone
                        ? require(`@/assets/combs/${item.item.icone}.svg`)
                        : require(`@/assets/combs/gas.svg`)
                    '
                    width='50px'
                    height='50px'
                    :fill='item.item.color'
                  />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-text='item.item.nome'
                    class='font-weight-medium'
                    :style='{ color: item.item.color }'
                  ></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              label='Valor do limite'
              outline
              v-money='money'
              v-model.lazy='valor_compra_comb'
            />
          </v-flex>
          <v-flex xs2>
            <v-btn @click='adicionarCombustivel' icon color='success'
              ><v-icon>add</v-icon></v-btn
            >
          </v-flex>
          <v-flex xs12 class='mb-4'>
            <h2>Combustíveis com Limite</h2>
            <v-list>
              <v-list-tile
                v-for='(item, index) in combustiveis_limitados'
                :key='`${index}a`'
              >
                <v-list-tile-avatar>
                  <svg-filler
                    :path='
                      item.combustivel.icone
                        ? require(`@/assets/combs/${item.combustivel.icone}.svg`)
                        : require(`@/assets/combs/gas.svg`)
                    '
                    width='50px'
                    height='50px'
                    :fill='item.combustivel.color'
                  />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-text='item.combustivel.nome'
                    class='font-weight-medium'
                    :style='{ color: item.combustivel.color }'
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-text='`Valor limite: ${formatar(item.valor_limite)}`'
                  >
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    icon
                    small
                    color='error'
                    @click='removerCombustivel(index, item)'
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile v-if='combustiveis_limitados.length === 0'>
                <v-list-tile-title class='font-weight-medium'
                  >Sem combustíveis na lista</v-list-tile-title
                >
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-slide-x-transition>
      <v-checkbox
        v-model='tem_limite_tempo'
        color='green'
        class='mt-0'
        :hide-details='tem_limite_tempo'
      >
        <template slot='label'>
          <span class='body-2 grey--text'
            >Tempo de realização de próxima compra</span
          >
        </template>
      </v-checkbox>
      <v-slide-x-transition>
        <v-select
          class='mt-4'
          v-show='tem_limite_tempo'
          label='Tempo que usuário poderá realizar a próxima compra'
          :items="[
            { text: '15 Min', value: 1 },
            { text: '30 Mim', value: 2 },
            { text: '45 Min', value: 3 },
            { text: '1 Hora', value: 4 },
            { text: '1 Dia', value: 5 },
          ]"
          v-model='limiteCompra.limite_tempo'
          outline
        />
      </v-slide-x-transition>
      <v-checkbox
        color='green'
        v-model='tem_limite_quantidade'
        class='mt-0'
        :hide-details='tem_limite_quantidade'
      >
        <template slot='label'>
          <span class='body-2 grey--text'>Quantidade de abastecimento</span>
        </template>
      </v-checkbox>
      <v-slide-x-transition>
        <v-text-field
          class='mt-4'
          type='number'
          v-show='tem_limite_quantidade'
          label='Quantidade de compra por dia'
          v-model='limiteCompra.qtd_compras'
          outline
        />
      </v-slide-x-transition>
      <div v-if='limiteCompra.is_app'>
        <v-checkbox
        v-model='tem_limite_cashposto'
        color='green'
        class='mt-0'
        :hide-details='tem_limite_cashposto'
      >
        <template slot='label'>
          <span class='body-2 grey--text'>Limite de valor do cashposto gerado</span>
        </template>
      </v-checkbox>
      <v-slide-x-transition>
        <v-layout
          wrap
          justify-space-around
          v-if='tem_limite_cashposto'
          class='mt-4'
        >
          <v-flex xs5>
            <v-text-field
              outline
              v-money='money'
              label='limite mínimo'
              v-model.lazy='valor_minimo_cashposto'
            />
          </v-flex>
          <v-flex xs5>
            <v-text-field
              outline
              v-money='money'
              label='limite máximo'
              v-model.lazy='valor_maximo_cashposto'
            />
          </v-flex>
        </v-layout>
      </v-slide-x-transition>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn block class='mb-2' color='success' @click='definirLimite'>
        <v-icon class='mr-2'>save</v-icon>
        Salvar
      </v-btn>
    </v-card-actions>
    <v-dialog
      width='400'
      v-if='dialogDeletarLimite'
      v-model='dialogDeletarLimite'
    >
      <dialog-deletar
        titulo='Tem certeza que deseja deletar o limite?'
        @nao='dialogDeletarLimite = false'
        @sim='deletarLimite'
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money'
import DialogDeletar from '@/components/dialogs/Deletar'

export default {
  components: { DialogDeletar },
  directives: { money: VMoney },
  data: () => ({
    alerta: undefined,
    cor: 'error',
    tipo: 'error',
    dialogDeletarLimite: false,
    carregado: false,
    tem_limite_cashposto: false,
    tem_limite_valor: false,
    tem_limite_combustivel: false,
    tem_limite_tempo: false,
    tem_limite_quantidade: false,
    combustivel: undefined,
    existe: false,
    valor_compra_comb: 'R$ 0,00',
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      precision: 2,
      masked: false
    },
    combustiveis_limitados: [],
    valor: null,
    valor_maximo_cashposto: null,
    valor_minimo_cashposto: null,
    qtd_compras: 1,
    limiteCompra: {
      id: null,
      descricao: null,
      periodo: null,
      valor: null,
      qtd_compras: null,
      limite_tempo: null,
      minimo_cashposto: null,
      maximo_cashposto: null,
      is_app: false
    }
  }),
  beforeMount () {
    this.pegarLimite()
  },
  watch: {
    valor_minimo_cashposto (val) {
      if (val) {
        this.limiteCompra.minimo_cashposto = val.split(' ')[1]
        this.limiteCompra.minimo_cashposto = this.limiteCompra.minimo_cashposto.replace(
          '.',
          ''
        )
        this.limiteCompra.minimo_cashposto = Number(
          this.limiteCompra.minimo_cashposto.replace(',', '.')
        )
      } else {
        this.limiteCompra.minimo_cashposto = val
      }
    },
    valor_maximo_cashposto (val) {
      if (val) {
        this.limiteCompra.maximo_cashposto = val.split(' ')[1]
        this.limiteCompra.maximo_cashposto = this.limiteCompra.maximo_cashposto.replace(
          '.',
          ''
        )
        this.limiteCompra.maximo_cashposto = Number(
          this.limiteCompra.maximo_cashposto.replace(',', '.')
        )
      } else {
        this.limiteCompra.maximo_cashposto = val
      }
    },
    valor (val) {
      if (val) {
        this.limiteCompra.valor = val.split(' ')[1]
        this.limiteCompra.valor = this.limiteCompra.valor.replace('.', '')
        this.limiteCompra.valor = Number(
          this.limiteCompra.valor.replace(',', '.')
        )
      } else {
        this.limiteCompra.valor = val
      }
    },
    tem_limite_valor (val) {
      if (!val) {
        this.valor = null
        this.limiteCompra.periodo = null
      }
    },
    tem_limite_cashposto (val) {
      if (!val) {
        this.valor_maximo_cashposto = null
        this.valor_minimo_cashposto = null
      }
    },
    tem_limite_combustivel (val) {
      if (!val) {
        this.combustiveis_limitados = []
      }
    },
    tem_limite_tempo (val) {
      if (!val) {
        this.limiteCompra.limite_tempo = null
      }
    },
    'limiteCompra.is_app' (val) {
      this.limiteCompra.id = null
      this.tem_limite_valor = false
      this.tem_limite_cashposto = false
      this.tem_limite_combustivel = false
      this.tem_limite_tempo = false
      this.tem_limite_quantidade = false
      this.existe = false
      this.pegarLimite()
    },
    tem_limite_quantidade (val) {
      if (!val) {
        this.limiteCompra.qtd_compras = null
      }
    }
  },
  computed: {
    combustiveis () {
      return this.$store.getters.combustiveis
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  methods: {
    prepararDados (dados) {
      this.limiteCompra = dados
      this.valor = this.formatar(this.limiteCompra.valor)
      this.valor_minimo_cashposto = this.formatar(
        this.limiteCompra.limite_minimo_cashposto
      )
      this.valor_maximo_cashposto = this.formatar(
        this.limiteCompra.limite_maximo_cashposto
      )
      this.tem_limite_valor = this.limiteCompra.valor !== null
      this.tem_limite_cashposto =
        this.limiteCompra.limite_maximo_cashposto != null ||
        this.limiteCompra.limite_minimo_cashposto != null
      this.tem_limite_combustivel =
        this.limiteCompra.limite_combustivel !== null
      this.tem_limite_tempo = this.limiteCompra.limite_tempo !== null
      this.tem_limite_quantidade = this.limiteCompra.qtd_compras !== null

      if (this.tem_limite_combustivel) this.combustiveis_limitados = this.limiteCompra.limite_combustivel
    },
    pegarLimite () {
      this.$store.dispatch('limiteDeCompra', {
        method: 'GET',
        parametros: {
          isapp: this.limiteCompra.is_app,
          id_rede: this.posto.rede
        }
      }
      ).then((limiteCompra) => {
        this.existe = true
        this.prepararDados(limiteCompra)
      })
    },
    deletarLimite () {
      this.$store
        .dispatch('limiteDeCompra', {
          body: {
            id_limite: this.limiteCompra.id
          },
          parametros: {
            id_rede: this.posto.rede
          },
          method: 'DELETE'
        })
        .then(() => {
          this.existe = false
          this.tem_limite_valor = false
          this.tem_limite_cashposto = false
          this.tem_limite_combustivel = false
          this.tem_limite_tempo = false
          this.tem_limite_quantidade = false
          this.dialogDeletarLimite = false
          this.$emit('success', 'Limite deletado com sucesso.')
        })
    },
    deletarLimiteCombustivel (id) {
      this.$store.dispatch('limiteDeCompra', {
        method: 'DELETE',
        body: {
          id_limite_combustivel: id
        },
        parametros: {
          id_rede: this.posto.rede
        }
      })
        .then(() => {
          this.pegarLimite()
        })
    },
    fechar () {
      this.valor = 0
      this.valor_maximo_cashposto = 0
      this.valor_minimo_cashposto = 0
      this.limiteCompra = {}
      this.$emit('fechar')
    },
    adicionarCombustivel () {
      if (!this.combustivel) {
        this.activeAlert('Combustível inválido.', 'error')
        return
      }
      if (this.valor_compra_comb === 'R$ 0,00') {
        this.activeAlert('Valor limite para combustível inválido.')
        return
      }
      let exite = false
      let combSelecionado = null
      for (var i = 0; i < this.combustiveis_limitados.length; i++) {
        if (
          this.combustiveis_limitados[i].combustivel.id_combustivel ===
          this.combustivel.id_combustivel
        ) {
          exite = true
          combSelecionado = this.combustiveis_limitados[i]
        }
      }
      if (!exite) {
        this.combustiveis_limitados.push({
          combustivel: this.combustivel,
          valor_limite: this.valor_compra_comb
        })
      } else {
        if (combSelecionado.valor_limite === this.valor_compra_comb) return undefined
        else combSelecionado.valor_limite = this.valor_compra_comb
      }
    },
    removerCombustivel (index, lc) {
      // lc = limite combustível
      if (lc.id) {
        this.deletarLimiteCombustivel(lc.id)
      }
      this.combustiveis_limitados.splice(index, 1)
    },
    formatar (valor) {
      if (typeof valor === 'string' && valor[0] === 'R') return valor
      if (valor === undefined) return null
      if (valor === null) return null
      if (valor === 0) return 'R$ 0,00'
      return `R$ ${valor.replace('.', ',')}`
    },
    definirLimite () {
      if (
        !this.tem_limite_valor &&
        !this.tem_limite_combustivel &&
        !this.tem_limite_cashposto &&
        !this.tem_limite_tempo &&
        !this.tem_limite_quantidade
      ) {
        this.activeAlert('Você precisa preencher algum campo', 'error')
        return
      }

      if (this.tem_limite_valor) {
        if (
          this.limiteCompra.valor === 0 ||
          this.limiteCompra.valor === undefined
        ) {
          this.activeAlert('Valor limite para compra inválido.', 'error')
          return
        } else if (
          this.limiteCompra.periodo === null ||
          this.limiteCompra.periodo === undefined
        ) {
          this.activeAlert('Período inválido.', 'error')
          return
        }
      }
      if (this.tem_limite_cashposto) {
        if (
          this.limiteCompra.maximo_cashposto === 0 ||
          this.limiteCompra.maximo_cashposto === undefined
        ) {
          this.activeAlert(
            'Valor de limite maximo para cashposto inválido.',
            'error'
          )
          return
        } else if (
          this.limiteCompra.minimo_cashposto === 0 ||
          this.limiteCompra.minimo_cashposto === undefined
        ) {
          this.activeAlert(
            'Valor de limite minimo para cashposto inválido.',
            'error'
          )
          return
        }
      }

      if (this.tem_limite_combustivel) {
        if (this.combustiveis_limitados.length === 0) {
          this.activeAlert(
            'Não foram inseridos combústiveis a lista.',
            'error'
          )
          return
        } else {
          for (var i = 0; i < this.combustiveis_limitados.length; i++) {
            if (this.combustiveis_limitados[i].valor_limite[0] === 'R') {
              let valor = this.combustiveis_limitados[i].valor_limite.split(
                ' '
              )[1]
              valor = valor.replace('.', '').replace(',', '.')
              this.combustiveis_limitados[i].valor_limite = valor
            }
          }
          this.limiteCompra.combustiveis_limitados = this.combustiveis_limitados
        }
      }

      if (
        this.tem_limite_tempo &&
       (this.limiteCompra.limite_tempo === 0 ||
          this.limiteCompra.limite_tempo === undefined ||
          this.limiteCompra.limite_tempo === null)
      ) {
        this.activeAlert('Tempo limite inválido', 'error')
        return
      }

      if (
        this.tem_limite_quantidade &&
       (this.limiteCompra.qtd_compras === 0 ||
          this.limiteCompra.qtd_compras === undefined ||
          this.limiteCompra.qtd_compras === null)
      ) {
        this.activeAlert('Quantidade de abastecimento inválida.', 'error')
        return
      }
      this.limiteCompra.id =
        this.limiteCompra.id === undefined || this.limiteCompra.id === null
          ? 0
          : this.limiteCompra.id
      this.$store.dispatch('limiteDeCompra', {
        body: this.limiteCompra,
        method: 'POST',
        parametros: {
          id_rede: this.posto.rede
        }
      }).then(json => {
        this.activeAlert(
          'Limite de compra cadastrado com sucesso',
          'success'
        )
        this.existe = true
        this.prepararDados(json)
        this.$emit('success', 'Limite cadastrado com sucesso.')
      }).catch(() => {
        this.$emit('error', 'Erro ao cadastrar limite.')
      })
    },
    activeAlert (text, type) {
      this.alerta = text
      this.tipo = type
      const interval = setInterval(() => {
        this.alerta = undefined
        clearInterval(interval)
      }, 5000)
    }
  }
}
</script>
